import { Link } from 'react-router'
import * as styles from './styles.css'
import title from './images/title.svg'
import image1 from '../desktop-hero/images/1.jpg'
import image2 from '../desktop-hero/images/2.jpg'
import image3 from '../desktop-hero/images/3.jpg'
import image4 from '../desktop-hero/images/4.jpg'
import image5 from '../desktop-hero/images/5.jpg'
import image6 from '../desktop-hero/images/6.jpg'
import image7 from '../desktop-hero/images/7.jpg'

const Title: React.FC<{ className?: string }> = ({ className = '' }) => (
  <h1 className="flex flex-row items-center">
    {/* imgだとCSSのcolorがSVG内のcurrentColorへ届かないので、maskで塗りをbg-current（=親のtext色）にする */}
    <span
      role="img"
      aria-label="バラの定期便"
      className="w-22 bg-white lg:bg-black"
      style={{
        maskImage: `url(${title})`,
        WebkitMaskImage: `url(${title})`,
        maskSize: 'contain',
        WebkitMaskSize: 'contain',
        maskRepeat: 'no-repeat',
        WebkitMaskRepeat: 'no-repeat',
        maskPosition: 'center',
        WebkitMaskPosition: 'center',
        aspectRatio: '96 / 476',
      }}
    />
  </h1>
)

export const HeroSection: React.FC = () => {
  return (
    <section className="relative bg-white h-[calc(100vh-56px)] lg:h-screen">
      {/* モバイル */}
      <div className="lg:hidden relative h-full overflow-hidden">
        <div className="absolute inset-0 w-full h-ful">
          <img className={styles.image} src={image7} style={{ animationDelay: '22.8s' }} />
          <img className={styles.image} src={image6} style={{ animationDelay: '19.0s' }} />
          <img className={styles.image} src={image5} style={{ animationDelay: '15.2s' }} />
          <img className={styles.image} src={image4} style={{ animationDelay: '11.4s' }} />
          <img className={styles.image} src={image3} style={{ animationDelay: '7.6s' }} />
          <img className={styles.image} src={image2} style={{ animationDelay: '3.8s' }} />
          <img className={styles.image} src={image1} style={{ animationDelay: '0s' }} />
        </div>
        <div className="absolute inset-0 bg-black/15" />
        <div className="absolute inset-0 flex items-center justify-center gap-16">
          <Title className="text-white" />
        </div>
        <p className="absolute top-12 right-8 text-white font-sans text-[20px] leading-[1.3] tracking-[0.2em]" style={{ writingMode: 'vertical-rl' }}>
          同じ花、なのに毎回違う。
        </p>
        <p className="absolute bottom-24 left-0 right-0 text-center text-[14px] font-semibold text-white" style={{ textShadow: '0 1px 6px rgba(0,0,0,0.3)' }}>
          月額 3,740円（送料無料）
        </p>
      </div>

      {/* デスクトップ */}
      <div className="hidden h-full lg:flex flex-col items-center relative">
        <div className="flex flex-1 items-center justify-center">
          <Title />
        </div>
        <div className="flex flex-col items-center pb-26">
          <p className="text-[14px] text-black font-medium">月額 3,740円（送料無料）</p>
        </div>
      </div>
    </section>
  )
}
